/**
 * Returns all focusable items in the element provided or the body of the document.
 */
export const getAllFocusable = htmlElement => {
  const parentElement = htmlElement ?? document.body;
  const focusableNodeList = parentElement.querySelectorAll('button, details, [href]:not(use), input, select, textarea, [tabindex]:not([tabindex="-1"])');
  const focusableArray = Array.from(focusableNodeList);
  // filter out focusable elements with tabindex = -1
  const focusable = focusableArray.filter(element => element.getAttribute('tabindex') === '-1' ? false : true)
  // filter out elements with 'disabled' attribute
  .filter(element => !element.hasAttribute('disabled'))
  // filter out elements and ancestor elements with 'display: none'
  .filter(element => {
    const computedStyle = parentElement.ownerDocument.defaultView?.getComputedStyle(element);
    if (computedStyle?.position === 'fixed' && computedStyle?.display !== 'none') {
      return true;
    }
    return element.offsetParent !== null;
  }).filter(element =>
  // uses window to getComputedStyle. must retrieve window as parameter may have different window
  parentElement.ownerDocument.defaultView?.getComputedStyle(element).display === 'none' ? false : true);
  return focusable;
};
/**
 * Returns first focusable item in the element provided or the body of the document.
 */
export const getFirstFocusable = htmlElement => {
  const focusable = getAllFocusable(htmlElement);
  return focusable.length > 0 ? focusable[0] : null;
};

/**
 * Returns the last focusable item in the element provided or the body of the document.
 */
export const getLastFocusable = htmlElement => {
  const focusable = getAllFocusable(htmlElement);
  return focusable.length > 0 ? focusable[focusable.length - 1] : null;
};

/**
 * Returns the next focusable element. Returns null if there is no focused element.
 * Returns the first focusable element if the current focused element is last.
 */
export const getNextFocusableElement = () => {
  // activeElement is an Element and HTMLElements are a more specic of Elements
  // HTMLElement check enforces compatability with getAllFocusable but if this
  // becomes a problem in the future, the typing of getAllFocusable could likely
  // be changed.
  if (!(document.activeElement instanceof HTMLElement)) return null;
  // this should never be empty if there is a currently focused element
  const focusable = getAllFocusable();
  const currentIndex = focusable.indexOf(document.activeElement);
  // body element can be the active element but is not counted in getAllFocusable
  return focusable[(currentIndex + 1) % focusable.length] ?? null;
};
//# sourceMappingURL=focus.js.map